import React, { useState, useEffect, useRef } from 'react'
import './faq.css';
import { motion } from 'framer-motion';
import questionData from './data';
const firstVariant = {
    hidden: {
        y: 100,
        opacity: 0
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            delay: .3,
            duration: 1
        }
    }
}
export default function Faq() {
    const [currentIndex, setCurrentIndex] = useState(null)
    const openAnswer = (index) => {
        if (index !== currentIndex) {
            setCurrentIndex(index)
        } else {
            setCurrentIndex(null)
        }
    }
    const [faqIsVisible, setFaqIsVisible] = useState(false)
    const faqIntersectionRef = useRef(null)
    useEffect(() => {
        const observer =  new IntersectionObserver ((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setFaqIsVisible(true)
                } else{
                    setFaqIsVisible(false)
                }
            })
        }, {
            threshold: 0.1
        })
        if (faqIntersectionRef.current) {
            observer.observe(faqIntersectionRef.current)   
        }
    })
    return (
        <motion.div className='faq-container'
            variants={firstVariant}
            initial="hidden"
            animate={faqIsVisible ? "visible" : "hidden"}
            ref={faqIntersectionRef}>
            <h3>Frequently Asked Questions</h3>
            {
                questionData.map((questions, index) => (
                    <div className={`question-box ${index === currentIndex ? "active-box" : ''}`} key={index} onClick={() => openAnswer(index)}>
                        <div className="question">
                            <p>{questions.question}</p>
                            {
                                index === currentIndex ? <i className='bx bx-minus'></i> : <i className='bx bx-plus'></i>
                            }
                        </div>
                        {
                            index === currentIndex && (
                                <div className="answer">
                                    <p>{questions.answer}</p>
                                </div>
                            )
                        }
                    </div>
                ))
            }
        </motion.div>
    )
}
